import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var _excluded$1 = ["styles"];
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
var CheckboxCheckedDisabled = (function (_ref) {
  _ref.styles;
    var props = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "8",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.396 7.843L.146 4.356a.564.564 0 010-.758l.708-.759a.476.476 0 01.707 0L3.75 5.188 8.44.158a.476.476 0 01.706 0l.708.758c.195.21.195.549 0 .758l-5.75 6.169a.476.476 0 01-.708 0z",
    fill: "#D0D6DA"
  }));
});

var _excluded = ["styles"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var CheckboxChecked = (function (_ref) {
  _ref.styles;
    var props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "8",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.396 7.843L.146 4.356a.564.564 0 010-.758l.708-.759a.476.476 0 01.707 0L3.75 5.188 8.44.158a.476.476 0 01.706 0l.708.758c.195.21.195.549 0 .758l-5.75 6.169a.476.476 0 01-.708 0z",
    fill: "#fff"
  }));
});

var Checkbox = function Checkbox(_a) {
  var isChecked = _a.isChecked,
    _b = _a.disabled,
    disabled = _b === void 0 ? false : _b,
    _c = _a.label,
    label = _c === void 0 ? "" : _c,
    onChange = _a.onChange,
    inputProps = __rest(_a, ["isChecked", "disabled", "label", "onChange"]);
  var labelClasses = classNames([!disabled && "cursor-pointer", "relative", "select-none", "inline-flex", "items-center", "border-box", {
    "tw:opacity-50": disabled
  }]);
  var tickboxClasses = classNames([{
    "bg-light tw:bg-white": disabled
  }, {
    "border-muted tw:border-tw-secondary-500": disabled
  }, {
    "border-secondary tw:border-tw-secondary-500": !disabled
  }, "peer-focus:border-secondary", "peer-hover:border-secondary", "peer-checked:bg-primary tw:peer-checked:bg-tw-primary-500", "peer-checked:border-secondary tw:peer-checked:border-tw-primary-500", "peer-disabled:bg-light peer-disabled:border-muted peer-disabled:hover:border-muted", "tw:peer-disabled:border-tw-secondary-500 tw:peer-disabled:hover:border-tw-secondary-500", "tw:peer-disabled:peer-checked:border-tw-primary-500 tw:peer-disabled:peer-checked:hover:border-tw-primary-500", "w-lg h-lg tw:w-[18px] tw:h-[18px]", "relative rounded-base border-solid border mr-sm overflow-hidden"]);
  var iconClasses = classNames(["absolute leading-[0px] transition-[top] duration-200", "top-[3px] left-[2px] tw:top-[4px] tw:left-[3px]", "h-[8px] w-[10px]"]);
  var style = {
    cursor: disabled ? "no-drop" : "",
    transition: "background-color 0.5s border 0.5s",
    minWidth: "1rem"
  };
  var textClasses = classNames([disabled && "text-muted", "tw:text-base tw:leading-150 tw:text-tw-secondary-800"]);
  var textProps = textClasses.length && {
    className: textClasses
  };
  var checkboxIcon = null;
  if (isChecked) {
    checkboxIcon = disabled ? /*#__PURE__*/React.createElement(CheckboxCheckedDisabled, null) : /*#__PURE__*/React.createElement(CheckboxChecked, null);
  }
  return /*#__PURE__*/React.createElement("label", {
    className: labelClasses
  }, /*#__PURE__*/React.createElement("input", __assign({
    className: "absolute opacity-0 peer",
    type: "checkbox",
    checked: isChecked,
    disabled: disabled,
    onChange: onChange,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, inputProps)), /*#__PURE__*/React.createElement("span", {
    className: tickboxClasses,
    style: style
  }, checkboxIcon && /*#__PURE__*/React.createElement("span", {
    className: iconClasses
  }, checkboxIcon)), /*#__PURE__*/React.createElement("span", __assign({}, textProps), label));
};
Checkbox.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};

export { Checkbox };
//# sourceMappingURL=index.es.js.map
